import { Deserializable } from '../../../models/protocols/deserializable';
import { GoverningJurisdictionTypeId } from '../../../models/enum/shared/governing-jurisdiction-type-id';
import { MemberAccountStatusIdEnum } from '../../../models/transactions/enum/member-account-status-id.enum';

export class IpCreateTransferredInAccountResponse implements Deserializable {
  public accountId!: number;
  public idPrefix!: string;
  public statusId!: MemberAccountStatusIdEnum;
  public governingJurisdictionId!: GoverningJurisdictionTypeId;

  public onDeserialize(): void {}
}
